import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setIsModalOpen, setModalContent, setModalContentProps } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { useAppDispatch } from '../../store';
import { useSelector } from 'react-redux';
import { selectInputTaskAnswerToDeleteId, setInputTaskAnswerToDeleteId, } from '../../store/adminSlices/rallies';
import Button from '../../ui/Button';
import Input from '../../ui/Input';
import AddIcon from '../../assets/icons/plus.svg';
import AdminInputTaskAnswerCard from '../../ui/AdminTaskAnswerCard/InputTaskAnswerCard';
import { generateId } from '../../helpers';
import { deleteAdminTaskAnswer, updateAdminTask } from '../../api/admin/tasks';
const AdminInputTaskAnswersList = ({ taskId, formState, formErrors, validateInputField, updatedFormFields, setUpdatedFormFields, setTaskUpdated, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const inputTaskAnswerToDeleteId = useSelector(selectInputTaskAnswerToDeleteId);
    const deleteBackendTaskAnswer = async (uid) => {
        try {
            await updateAdminTask(taskId, {
                answers: formState.inputTaskAnswers.map((answer) => ({
                    ...(answer.uid ? { uid: answer.uid } : {}),
                    content: answer.translations,
                })),
            });
            await deleteAdminTaskAnswer(String(uid));
            dispatch(setInputTaskAnswerToDeleteId(null));
            setTaskUpdated(true);
        }
        catch (error) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    useEffect(() => {
        const handleDeleteTaskAnswer = async (answerToDelete) => {
            if (updatedFormFields.has('inputTaskAnswers')) {
            }
            const answerToDeleteBackendId = answerToDelete?.uid;
            if (answerToDeleteBackendId) {
                await deleteBackendTaskAnswer(answerToDeleteBackendId);
            }
            else {
                formState.setInputTaskAnswers((prev) => prev.filter((answer) => answer.clientId !== answerToDelete.clientId));
                setUpdatedFormFields((prev) => {
                    const newSet = new Set(prev);
                    newSet.add('inputTaskAnswers');
                    return newSet;
                });
            }
        };
        if (inputTaskAnswerToDeleteId) {
            const answerToDelete = formState.inputTaskAnswers.find((answer) => answer.clientId === inputTaskAnswerToDeleteId);
            if (answerToDelete) {
                handleDeleteTaskAnswer(answerToDelete);
            }
        }
    }, [inputTaskAnswerToDeleteId]);
    const onAddAnswer = () => {
        formState.setInputTaskAnswers((prev) => [
            ...prev,
            {
                uid: null,
                translations: { de: '', en: '', cs: '' },
                clientId: generateId('input-answer'),
            },
        ]);
        setUpdatedFormFields((prev) => {
            const newSet = new Set(prev);
            newSet.add('inputTaskAnswers');
            return newSet;
        });
    };
    const onDeleteAnswer = (answerClientId) => {
        if (updatedFormFields.has('inputTaskAnswers')) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.cannotDeleteTaskAnswer.key));
            dispatch(setModalContentProps({
                title: t('admin.cannot_delete_task_answer_title'),
                message: t('admin.save_local_changes'),
            }));
        }
        else {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.confirmDeleteTaskAnswer.key));
            dispatch(setModalContentProps({
                answerId: answerClientId,
                taskType: 'input-task',
            }));
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "admin-task-answers-list", children: [formState.inputTaskAnswers &&
                    formState.inputTaskAnswers.map((answer, index) => (_jsx(AdminInputTaskAnswerCard, { inputTaskAnswer: answer, inputTaskIndex: index, formState: formState, formErrors: formErrors, validateInputField: validateInputField, setUpdatedFormFields: setUpdatedFormFields, onDeleteInputTaskAnswer: onDeleteAnswer }, answer.clientId))), _jsx("div", { className: "task-answer-item input-task", children: _jsxs("div", { className: "task-answer-item-header", children: [_jsx("div", { className: "task-answer-order-controls", children: _jsx("div", { className: "task-answer-order", children: _jsx("span", { children: formState.inputTaskAnswers.length + 1 }) }) }), _jsx(Input, { color: 'gray', id: 'additional-answer', value: '', name: 'additional-answer', placeholder: t('label.additional_answer'), onChange: () => { }, disabled: true, additionalContent: _jsx(Button, { shape: 'square', icon: _jsx(AddIcon, {}), iconSize: 'small', onClick: onAddAnswer }) })] }) })] }) }));
};
export default AdminInputTaskAnswersList;
